import { globalObject } from "../globalObject/globalObject.js";
//#region src/utils/sourceMaps.ts
/**
* Reads the bundle id injected by `@grafana/faro-metro-plugin` / webpack plugin preamble.
* Prefer `globalObject` (globalThis-first). Also check `window` for older bundles that set the
* property only on `window` when it differed from `globalThis` (e.g. legacy preamble order).
*/
function getBundleId(appName) {
	const key = `__faroBundleId_${appName}`;
	const fromGlobal = globalObject === null || globalObject === void 0 ? void 0 : globalObject[key];
	if (typeof fromGlobal === "string" && fromGlobal !== "") return fromGlobal;
	const fromWindow = typeof window !== "undefined" ? window[key] : void 0;
	if (typeof fromWindow === "string" && fromWindow !== "") return fromWindow;
}
function getGitHash(appName) {
	return globalObject === null || globalObject === void 0 ? void 0 : globalObject[`__faroGitHash_${appName}`];
}
//#endregion
export { getBundleId, getGitHash };

//# sourceMappingURL=sourceMaps.js.map